import { pages } from 'shared/constants/urls';
import { pushEvent } from 'helpers/utils/dataLayer';

export const canGoBack = () => {
  const referrer = document.referrer || '';
  // can go back if referrer is same as our domain
  return referrer.indexOf(window.location.host) >= 0;
};

// TODO: shift this to a common util
export const handleHistoryBack = () => {
  const BACK_BTN_CLICK = 'backButtonClicked';
  if (canGoBack()) {
    pushEvent(BACK_BTN_CLICK);
    window.history.back();
  } else {
    window.location.href = `${pages.HOME}?${BACK_BTN_CLICK}=1`;
  }
};
